import { useDispatch } from "react-redux";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomDateTimePicker from "../../../../components/CustomDateTimePicker";
import { Helpers } from "../../../../helpers/Helpers";
import { GetConstantListResponse } from "../../../../models/response/constant/GetConstantListResponse";
import { ConstantService } from "../../../../services/ConstantService";
import { OrderStatusAmbarEnum } from "../../../../models/common/Enums";
import toast from "react-hot-toast";
import { storeActivityIndicator } from "../../../../redux/reducers/authSlice";
import { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomTextInput from "../../../../components/CustomTextInput";
import { hedefSiparisDurumu } from "./siparisDurumu";

interface Props {
    dateInformationRef: any
    orderDate: string | undefined
    setOrderDate: React.Dispatch<React.SetStateAction<string | undefined>>
    loadDate: string | undefined
    setLoadDate: React.Dispatch<React.SetStateAction<string | undefined>>
    deliveryDate: string | undefined
    setDeliveryDate: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedOrderStatus: CustomSingleSelectModel | undefined
    setSelectedOrderStatus: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    shippingDeliverer: string | undefined
    setShippingDeliverer: React.Dispatch<React.SetStateAction<string | undefined>>
    shippingReceiver: string | undefined
    setShippingReceiver: React.Dispatch<React.SetStateAction<string | undefined>>
}

const DateInformation = ({
    dateInformationRef,
    deliveryDate,
    loadDate,
    orderDate,
    setDeliveryDate,
    setLoadDate,
    setOrderDate,
    selectedOrderStatus,
    setSelectedOrderStatus,
    setShippingDeliverer,
    setShippingReceiver,
    shippingDeliverer,
    shippingReceiver
}: Props) => {
    const dispatch = useDispatch();

    /**
     * Siparis Durumunu iki tarihe gore ayarlar. Doldurma ve silme simetriktir;
     * kural hedefSiparisDurumu'nda. Eskiden durum yalniz alan DOLDURULUNCA
     * degisiyordu, silinince eski durum kaliyordu ve mobilde yuk "teslim edildi"
     * gorunmeye devam ediyordu.
     */
    const durumuTarihlereGoreAyarla = async (_loadDate: string | undefined, _deliveryDate: string | undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var tumDurumlar: GetConstantListResponse = await ConstantService.getConstantList('ORDER_STATUS_AMBAR');

            if (!tumDurumlar.isSuccess) {
                toast.error(tumDurumlar.message)
                return;
            }

            var mevcutKod = tumDurumlar.data.find(x => x.constantId == selectedOrderStatus?.value)?.additionalValue1;

            var hedefKod = hedefSiparisDurumu(_loadDate, _deliveryDate, mevcutKod as OrderStatusAmbarEnum | undefined);

            if (hedefKod == undefined)
                return;

            var hedef = tumDurumlar.data.find(x => x.additionalValue1 == hedefKod);

            if (hedef)
                setSelectedOrderStatus({ label: hedef.value, value: hedef.constantId });
        } catch (error: any) {
            toast.error(error);
        }
        finally {
            dispatch(storeActivityIndicator(false));
        }
    }

    const onOrderDateChange = async (_value: string | undefined) => {
        setOrderDate(_value);

        await durumuTarihlereGoreAyarla(loadDate, deliveryDate);
    }

    const onLoadDateChange = async (_value: string | undefined) => {
        setLoadDate(_value);

        await durumuTarihlereGoreAyarla(_value, deliveryDate);
    }

    const onDeliveryDateChange = async (_value: string | undefined) => {
        setDeliveryDate(_value);

        await durumuTarihlereGoreAyarla(loadDate, _value);
    }

    return (
        <div className='containerPart' ref={dateInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Tarih ve Teslimat Bilgileri</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <CustomDateTimePicker labelText="Sipariş Tarihi" isLabelRequired value={orderDate} setValue={onOrderDateChange} />
                        </div>

                        <div className="col-md-4">
                            <CustomDateTimePicker labelText="Yükleme Tarihi" value={loadDate} setValue={onLoadDateChange} />
                        </div>

                        <div className="col-md-4">
                            <CustomDateTimePicker labelText="Teslim Tarihi" value={deliveryDate} setValue={onDeliveryDateChange} />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomTextInput labelText="Teslim Eden" isLabelRequired value={shippingDeliverer} setValue={setShippingDeliverer} />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput labelText="Teslim Alan" isLabelRequired value={shippingReceiver} setValue={setShippingReceiver} />
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default DateInformation;